import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FileText, Plus, Wand2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import AdminLayout from '@/components/admin/AdminLayout';
import { supabase } from '@/integrations/supabase/client';

const AdminDashboard = () => {
  const [blogCount, setBlogCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const { count } = await supabase.from('blog_posts').select('id', { count: 'exact', head: true });
        setBlogCount(count || 0);
      } catch (error) { console.error('Error fetching stats:', error); }
      finally { setLoading(false); }
    };
    fetchStats();
  }, []);

  return (
    <AdminLayout>
      <div className="space-y-8">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Dashboard</h1>
          <p className="text-muted-foreground mt-1">Welcome to the ACG CMS</p>
        </div>
        <div className="grid gap-4 md:grid-cols-3">
          <Link to="/admin/blog">
            <Card className="hover:bg-muted/50 transition-colors cursor-pointer">
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-muted-foreground">Blog Posts</CardTitle>
                <FileText className="h-4 w-4 text-blue-500" />
              </CardHeader>
              <CardContent><div className="text-2xl font-bold">{loading ? '...' : blogCount}</div></CardContent>
            </Card>
          </Link>
        </div>
        <Card>
          <CardHeader><CardTitle>Quick Actions</CardTitle><CardDescription>Common tasks to get you started</CardDescription></CardHeader>
          <CardContent>
            <div className="flex flex-wrap gap-3">
              <Link to="/admin/blog/new"><Button variant="outline" className="gap-2"><Plus className="h-4 w-4" />New Blog Post</Button></Link>
              <Link to="/admin/blog/bulk"><Button variant="outline" className="gap-2"><FileText className="h-4 w-4" />Bulk Upload Posts</Button></Link>
              <Link to="/admin/blog/auto"><Button variant="outline" className="gap-2"><Wand2 className="h-4 w-4" />Auto Generate Articles</Button></Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
